/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */

export const transactionDisputeCustomFieldsNZ = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390538 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  Type: { prod: 360013721973, nonProd: "NA" },
  Priority: { prod: 360013721993, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "DOB DD/MM/YYYY": { prod: 360006254998, nonProd: 360010666198 },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  Address: { prod: 360005089238, nonProd: 360010708997 },
  "Suburb or City": { prod: 360006142138, nonProd: 360010707437 },
  "Province/Region": { prod: 360006716877, nonProd: 360010668558 },
  "Postcode AU/NZ": { prod: 360006163997, nonProd: 360010669798 },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "Type of dispute ": { prod: 360006047057, nonProd: 360010707177 },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Number of transactions": { prod: 360006090077, nonProd: 360010707757 },
  "Visible in OSC?": { prod: 360006023438, nonProd: 360010669198 },
  "Associated Card": { prod: 360006047077, nonProd: 360010707977 },
  "Mail card to existing account address?": {
    prod: 360006023458,
    nonProd: 360010670398,
  },
  "New mailing address": { prod: 360006047097, nonProd: 360010669538 },
  "Transaction Date 1": { prod: 360007584098, nonProd: 360010668398 },
  "Merchant Name 1": { prod: 360007584318, nonProd: 360010666778 },
  "Transaction Amount 1": { prod: 360006047017, nonProd: 360010670798 },
  "Transaction Date 2": { prod: 360007584118, nonProd: 360010669418 },
  "Merchant Name 2": { prod: 360007584338, nonProd: 360010707277 },
  "Transaction Amount 2": { prod: 360007584498, nonProd: 360010710777 },
  "Transaction Date 3": { prod: 360007584138, nonProd: 360010670858 },
  "Merchant Name 3": { prod: 360007580037, nonProd: 360010710237 },
  "Transaction Amount 3": { prod: 360007584518, nonProd: 360010708457 },
  "Transaction Date 4": { prod: 360007579937, nonProd: 360010710037 },
  "Merchant Name 4": { prod: 360007584358, nonProd: 360010708137 },
  "Transaction Amount 4": { prod: 360007584538, nonProd: 360010669758 },
  "Transaction Date 5": { prod: 360007579957, nonProd: 360010706157 },
  "Merchant Name 5": { prod: 360007584378, nonProd: 360010669678 },
  "Transaction Amount 5": { prod: 360007580157, nonProd: 360010666338 },
  "Transaction Date 6": { prod: 360007584158, nonProd: 360010666678 },
  "Merchant Name 6": { prod: 360007580057, nonProd: 360010666418 },
  "Transaction Amount 6": { prod: 360007580177, nonProd: 360010669258 },
  "Transaction Date 7": { prod: 360007579977, nonProd: 360010706957 },
  "Merchant Name 7": { prod: 360007584398, nonProd: 360010710757 },
  "Transaction Amount 7": { prod: 360007580197, nonProd: 360010710357 },
  "Transaction Date 8": { prod: 360007584178, nonProd: 360010667638 },
  "Merchant Name 8": { prod: 360007580077, nonProd: 360010706977 },
  "Transaction Amount 8": { prod: 360007584558, nonProd: 360010705837 },
  "Transaction Date 9": { prod: 360007584198, nonProd: 360010668418 },
  "Merchant Name 9": { prod: 360007580097, nonProd: 360010707717 },
  "Transaction Amount 9": { prod: 360007584578, nonProd: 360010666878 },
  "Transaction Date 10": { prod: 360007584238, nonProd: 360010710537 },
  "Merchant Name 10": { prod: 360007580117, nonProd: 360010708877 },
  "Transaction Amount 10": { prod: 360007580217, nonProd: 360010706317 },
  "Transaction Date 11": { prod: 360007584258, nonProd: 360010668678 },
  "Merchant Name 11": { prod: 360007584418, nonProd: 360010706537 },
  "Transaction Amount 11": { prod: 360007584598, nonProd: 360010707417 },
  "Transaction Date 12": { prod: 360007579997, nonProd: 360010707677 },
  "Merchant Name 12": { prod: 360007580137, nonProd: 360010670438 },
  "Transaction Amount 12": { prod: 360007584618, nonProd: 360010708397 },
  "Transaction Date 13": { prod: 360007580017, nonProd: 360010708897 },
  "Merchant Name 13": { prod: 360007584438, nonProd: 360010707357 },
  "Transaction Amount 13": { prod: 360007580237, nonProd: 360010667338 },
  "Transaction Date 14": { prod: 360007584278, nonProd: 360010709397 },
  "Merchant Name 14": { prod: 360007584458, nonProd: 360010668518 },
  "Transaction Amount 14": { prod: 360007584638, nonProd: 360010669918 },
  "Transaction Date 15": { prod: 360007584298, nonProd: 360010710697 },
  "Merchant Name 15": { prod: 360007584478, nonProd: 360010709637 },
  "Transaction Amount 15": { prod: 360007580257, nonProd: 360010707877 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  Subject: { prod: 360013721913, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
};

export const transactionDisputeCustomFieldsAu = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390118 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  Type: { prod: 360013721973, nonProd: "NA" },
  Priority: { prod: 360013721993, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "DOB DD/MM/YYYY": { prod: 360006254998, nonProd: 360010666198 },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  Address: { prod: 360005089238, nonProd: 360010708997 },
  "Suburb or City": { prod: 360006142138, nonProd: 360010707437 },
  State: { prod: 360006357538, nonProd: 360010670198 },
  "Postcode AU/NZ": { prod: 360006163997, nonProd: 360010669798 },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "Number of transactions": { prod: 360006090077, nonProd: 360010707757 },
  "Type of dispute ": { prod: 360006047057, nonProd: 360010707177 },
  "Visible in OSC?": { prod: 360006023438, nonProd: 360010669198 },
  "Associated Card": { prod: 360006047077, nonProd: 360010707977 },
  "Mail card to existing account address?": {
    prod: 360006023458,
    nonProd: 360010670398,
  },
  "New mailing address": { prod: 360006047097, nonProd: 360010669538 },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Transaction Date 1": { prod: 360007584098, nonProd: 360010668398 },
  "Merchant Name 1": { prod: 360007584318, nonProd: 360010666778 },
  "Transaction Amount 1": { prod: 360006047017, nonProd: 360010670798 },
  "Transaction Date 2": { prod: 360007584118, nonProd: 360010669418 },
  "Merchant Name 2": { prod: 360007584338, nonProd: 360010707277 },
  "Transaction Amount 2": { prod: 360007584498, nonProd: 360010710777 },
  "Transaction Date 3": { prod: 360007584138, nonProd: 360010670858 },
  "Merchant Name 3": { prod: 360007580037, nonProd: 360010710237 },
  "Transaction Amount 3": { prod: 360007584518, nonProd: 360010708457 },
  "Transaction Date 4": { prod: 360007579937, nonProd: 360010710037 },
  "Merchant Name 4": { prod: 360007584358, nonProd: 360010708137 },
  "Transaction Amount 4": { prod: 360007584538, nonProd: 360010669758 },
  "Transaction Date 5": { prod: 360007579957, nonProd: 360010706157 },
  "Merchant Name 5": { prod: 360007584378, nonProd: 360010669678 },
  "Transaction Amount 5": { prod: 360007580157, nonProd: 360010666338 },
  "Transaction Date 6": { prod: 360007584158, nonProd: 360010666678 },
  "Merchant Name 6": { prod: 360007580057, nonProd: 360010666418 },
  "Transaction Amount 6": { prod: 360007580177, nonProd: 360010669258 },
  "Transaction Date 7": { prod: 360007579977, nonProd: 360010706957 },
  "Merchant Name 7": { prod: 360007584398, nonProd: 360010710757 },
  "Transaction Amount 7": { prod: 360007580197, nonProd: 360010710357 },
  "Transaction Date 8": { prod: 360007584178, nonProd: 360010667638 },
  "Merchant Name 8": { prod: 360007580077, nonProd: 360010706977 },
  "Transaction Amount 8": { prod: 360007584558, nonProd: 360010705837 },
  "Transaction Date 9": { prod: 360007584198, nonProd: 360010668418 },
  "Merchant Name 9": { prod: 360007580097, nonProd: 360010707717 },
  "Transaction Amount 9": { prod: 360007584578, nonProd: 360010666878 },
  "Transaction Date 10": { prod: 360007584238, nonProd: 360010710537 },
  "Merchant Name 10": { prod: 360007580117, nonProd: 360010708877 },
  "Transaction Amount 10": { prod: 360007580217, nonProd: 360010706317 },
  "Transaction Date 11": { prod: 360007584258, nonProd: 360010668678 },
  "Merchant Name 11": { prod: 360007584418, nonProd: 360010706537 },
  "Transaction Amount 11": { prod: 360007584598, nonProd: 360010707417 },
  "Transaction Date 12": { prod: 360007579997, nonProd: 360010707677 },
  "Merchant Name 12": { prod: 360007580137, nonProd: 360010670438 },
  "Transaction Amount 12": { prod: 360007584618, nonProd: 360010708397 },
  "Transaction Date 13": { prod: 360007580017, nonProd: 360010708897 },
  "Merchant Name 13": { prod: 360007584438, nonProd: 360010707357 },
  "Transaction Amount 13": { prod: 360007580237, nonProd: 360010667338 },
  "Transaction Date 14": { prod: 360007584278, nonProd: 360010709397 },
  "Merchant Name 14": { prod: 360007584458, nonProd: 360010668518 },
  "Transaction Amount 14": { prod: 360007584638, nonProd: 360010669918 },
  "Transaction Date 15": { prod: 360007584298, nonProd: 360010710697 },
  "Merchant Name 15": { prod: 360007584478, nonProd: 360010709637 },
  "Transaction Amount 15": { prod: 360007580257, nonProd: 360010707877 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
};
